/* eslint-disable react/button-has-type */
import React from 'react';
import { Link } from 'react-router-dom';
import './Main.css';

const Main = () => {
  return (
    <div
      className="App-main"
      style={{
        backgroundImage: `url(./assets/bg.jpg)`,
      }}
    >
      <div className="App-main__blur">
        <div
          className="App-main__ball-one"
          style={{
            backgroundImage: `url(./assets/ball/3.png)`,
          }}
        />
        <div
          className="App-main__ball-two"
          style={{
            backgroundImage: `url(./assets/ball/3.png)`,
          }}
        />
        <div className="App-main__title">
          <h3>
            У вашей бабушки скопилось большое количество ёлочных игрушек. Она
            попросила вас помочь их разобрать, чтобы выбрать те, которыми будет
            наряжать ёлку в этом году.
          </h3>
        </div>
        <button className="App-main__btn-start">
          <Link to="/toys">Помочь бабушке</Link>
        </button>
      </div>
    </div>
  );
};

export default Main;
